import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicationFinderBannerComponent } from './medication-finder-banner.component';
import { TranslateModule } from '@ngx-translate/core';
import { DlsBannerModule } from '@zelis/dls/banner';

@NgModule({
  imports: [CommonModule, TranslateModule, DlsBannerModule],
  declarations: [MedicationFinderBannerComponent],
  exports: [MedicationFinderBannerComponent],
})
export class MedicationFinderBannerModule {}
